import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { RESPONSE_FILTER_VALUES } from '@constants';
import { Item } from '@interfaces';
import { OrderService } from '@services';

const FILTER_VALUES = {
  ASSIGNED_TO_ALL: 'assigned-to-all',
  ASSIGNED_TO_ME: 'assigned-to-me',
} as const;

@Component({
  selector: 'unicon-menu-filters',
  templateUrl: './menu-filters.component.html',
  styleUrls: ['./menu-filters.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MenuFiltersComponent implements OnInit {
  @Input() selected: string = '';
  @Input() selectedResponseType: string = RESPONSE_FILTER_VALUES.ALL;
  @Input() selectedBusinessLines: string[] = [];
  @Input() loading: boolean = false;
  @Output() agent: EventEmitter<string> = new EventEmitter<string>();
  @Output() responseTypeChange: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() businessLinesChange: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();
  protected readonly FILTER_VALUES = FILTER_VALUES;
  protected readonly RESPONSE_FILTER_VALUES = RESPONSE_FILTER_VALUES;
  protected businessUnit: Item[] = [];

  constructor(private orderService: OrderService) {}

  ngOnInit(): void {
    this.getBusinessLineFilters();
  }

  changeFilter(value: string) {
    if (value === this.selected) {
      return;
    }
    this.selected = value;
    this.agent.emit(value);
  }

  changeResponseFilter(value: string) {
    if (value === this.selectedResponseType) {
      return;
    }
    this.selectedResponseType = value;
    this.responseTypeChange.emit(value);
  }

  private getBusinessLineFilters(): void {
    this.orderService.getBusinessLinesFilters().subscribe({
      next: (filters: Item[]) => {
        this.businessUnit = filters;
      },
    });
  }

  protected onBusinessLineToggle(businessLine: string, checked: boolean): void {
    if (checked) {
      const updatedLines = [...this.selectedBusinessLines, businessLine];
      this.selectedBusinessLines = updatedLines;
      this.businessLinesChange.emit(updatedLines);
    } else {
      if (this.selectedBusinessLines.length === 1) {
        return;
      }
      const updatedLines = this.selectedBusinessLines.filter(
        bl => bl !== businessLine,
      );
      this.selectedBusinessLines = updatedLines;
      this.businessLinesChange.emit(updatedLines);
    }
  }

  protected isBusinessLineSelected(businessLine: string): boolean {
    return this.selectedBusinessLines.includes(businessLine);
  }

  protected isLastBusinessLineSelected(businessLine: string): boolean {
    return (
      this.isBusinessLineSelected(businessLine) &&
      this.selectedBusinessLines.length === 1
    );
  }
}
